var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))]),_c('div',{staticClass:"mouth"},[_vm._v(_vm._s(_vm.mouth))])]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"avater"})])
}]

export { render, staticRenderFns }